import {Component, Inject} from '@angular/core';
import {FieldType} from '@ngx-formly/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {ModalComponent} from '../modal/modal.component';

export interface IImage {
  id: number;
  image_alt: string;
  image_path: string;
}

@Component({
  selector: 'lib-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css']
})
export class GalleryComponent  extends FieldType {

  gallery: IImage[] = [];
  dialogConfig = new MatDialogConfig();
  staticUrl: string;

  constructor(public dialog: MatDialog, @Inject('config') config) {
    super();
    this.dialogConfig.disableClose = false;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.data = {multiple: false};
    this.dialogConfig.height = '470';
    this.dialogConfig.width = '70%';
    this.staticUrl = config.staticUrl;
  }



  onRemoveImageGallery(id: number): void {
    this.model.gallery = this.gallery = this.gallery.filter((value) => value.id !== id);
  }

  uploadGalleryImages(): void {

    this.dialogConfig.data = {multiple: true};
    const dialogRef = this.dialog.open(ModalComponent, this.dialogConfig);
    dialogRef.componentInstance.OnImages.subscribe(galleryData => {
      const uploadImages = galleryData.map(image => {
        image.image_path = this.staticUrl + '/' + image.path;
        return image;
      });
      this.gallery.push(...uploadImages);
      this.model.gallery = this.gallery;

    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

}
